import type { FC } from "react";

import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import FeatureUpgradeBanner from "../components/FeatureUpgradeBanner/FeatureUpgradeBanner";
import trackingService from "../services/tracking/trackingService";

type AdIntelligenceVariant =
    | "ad_spend_volume_filter"
    | "ad_spend_channels_filter"
    | "display_ads_format_filter"
    | "column";

interface IAdIntelligenceUpgradeBannerProps {
    hasHeader?: boolean;
    isSubmitted: boolean;
    onSubmit: () => void;
    variant: AdIntelligenceVariant;
}

const AdIntelligenceUpgradeBanner: FC<IAdIntelligenceUpgradeBannerProps> = ({
    hasHeader = false,
    isSubmitted,
    onSubmit,
    variant,
}) => {
    const TRIAL_BANNER_TEXT_KEYS = {
        contentHook: `si.ad_intelligence.${variant}.hook.content`,
        headerHook: `si.ad_intelligence.${variant}.hook.header`,
        buttonHook: `si.ad_intelligence.${variant}.hook.button`,
        headerKey: `si.ad_intelligence.${variant}.hook.title`,
    };

    return (
        <FeatureUpgradeBanner
            titleKey={TRIAL_BANNER_TEXT_KEYS.headerHook}
            subtitleKey={TRIAL_BANNER_TEXT_KEYS.contentHook}
            buttonTextKey={TRIAL_BANNER_TEXT_KEYS.buttonHook}
            headerKey={hasHeader ? TRIAL_BANNER_TEXT_KEYS.headerKey : undefined}
            onSubmit={() => {
                onSubmit();
                trackingService.trackFeatureAccessRequested("SI Ad Intelligence");
                void requestFeature("SI Ad Intelligence");
            }}
            isSubmitted={isSubmitted}
        />
    );
};

export default AdIntelligenceUpgradeBanner;
